import { AdhesionInsuredPeopleInterface } from '../../../../interfaces/dto/sales-portal/adhesion-insured-people/adhesion-insured-people-interface';

export class AdhesionInsuredPeopleModel implements AdhesionInsuredPeopleInterface {
  personId?: number;
  personalIdentificationNumber?: number;
  proposalId?: number;
  affinity: string = '';
  birthDate: Date = new Date();
  email: string = '';
  gender: string = '';
  isPolicyHolder: boolean = false;
  mobile: string = '';
  name: string = '';
  taxNumber: string = '';
  taxNumberCountry: string = '';
  transference?: string;
  contactType?: string;
  taxNumberCode: string = '';
  mobileCode: string = '';
  consents: number[] = [];

  constructor(init?: Partial<AdhesionInsuredPeopleModel>) {
    Object.assign(this, init);
  }
}
